module.exports = __webpack_public_path__ + "img/ic_12_arrow_down.9c40b5fd.svg";